var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"404-page"},[_c('div',{staticClass:"empty-img-box"},[_c('img',{staticClass:"logo-img",attrs:{"src":require("@/assets/images/blank.png")}}),_c('p',{staticClass:"placeholder"},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")]),_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.handleClick}},[_vm._v("\n      返回\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }